import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={props.width || 16}
      height={props.height || 20}
      viewBox="0 0 16 20"
      fill="none"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0H0v20h6V0zm10 0h-6v20h6V0z"
        fill="#E40046"
      />
    </Svg>
  );
}

export default SvgComponent;
